import { Grid } from "@mui/material";
import { AppOrderBenefitientsStringsConnector } from "../AppOrderBenefitientsStringsConnector";
import { Control, FieldValues, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { OrderFormValues } from "../../models/orderFormValues";

interface Props {
    control: Control<FieldValues>;
    fields: Partial<Record<"id", string>>[];
    append: (value: FieldValues | FieldValues[]) => void;
    remove: (index?: number | number[] | undefined) => void;
    handleSetTotalItemRows: (count: number) => void;
    setValue: UseFormSetValue<any>;
    watch: UseFormWatch<OrderFormValues>;
}

export default function OrderFormBenefitients({ control, fields, append, remove, handleSetTotalItemRows, setValue, watch }: Props) {
    return (
        <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid item xs={12}>
                <AppOrderBenefitientsStringsConnector
                    control={control}
                    fields={fields}
                    append={append}
                    remove={remove}
                    setValue={setValue}
                    watch={watch}  // Make sure watch is passed here
                    label="Uczestnicy"
                    handleSetTotalItemRows={handleSetTotalItemRows}
                />
            </Grid>
        </Grid>
    );
}